export default "__VITE_ASSET__403faf9e__"